export default "__VITE_ASSET__S630tVIS__"